import { TCountryCode, getEmojiFlag } from "countries-list";

import { MapPin } from "lucide-react";
import { PostalCodeData } from "@/data/zipcode";
import { Skeleton } from "@/shadcn/ui/skeleton";

interface ShowsNearbyHeaderProps {
  location: PostalCodeData | null;
  isShowingChangeLocation: boolean;
  countryCode: string | null;
  handleLocationModalOpen: () => void;
}

export default function ShowsNearbyHeader({
  location,
  isShowingChangeLocation,
  countryCode,
  handleLocationModalOpen,
}: ShowsNearbyHeaderProps) {
  return (
    <div className="flex flex-col gap-4 pt-4 md:pt-8">
      {/* Header Section */}
      <h1 className="font-sans text-slate-gray-900 font-semibold text-[26px] normal-case leading-tight">
        Shows Nearby
      </h1>
      <form
        className="my-0.5 leading-7 flex flex-row items-center"
        onSubmit={(e) => e.preventDefault()}
      >
        {location || isShowingChangeLocation ? (
          <div className="flex flex-row items-center gap-x-4 gap-y-2 w-full justify-between md:justify-start flex-wrap">
            <div className="flex flex-row items-center gap-2">
              <MapPin className="w-6 h-6 text-primary-blue flex-shrink-0" />
              <span className="flex-1 min-w-0 truncate leading-tight text-[18px] font-semibold text-primary-blue">
                {location ? (
                  <>
                    {getEmojiFlag(countryCode as TCountryCode)} {location.city}
                    {location.state_abbreviation &&
                      `, ${location.state_abbreviation}`}
                  </>
                ) : (
                  "Set your location"
                )}
              </span>
              {/* Only show the Change Location button if feature gate is enabled */}
            </div>
            <button
              type="button"
              onClick={handleLocationModalOpen}
              className="text-primary hover:text-primary/90 underline underline-offset-2 font-bold text-sm flex-shrink-0"
            >
              {location ? "Change location" : "Set location"}
            </button>
          </div>
        ) : (
          <Skeleton className="w-full max-w-[370px] h-[28px]" />
        )}
      </form>
    </div>
  );
}
